import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';

import Button from 'app/common/ui/Button';
import * as popupActions from 'app/common/actions/popup';
import getNumEnding from '../../../../lib/getNumEnding';
import * as pollActions from '../../../../actions/fund/poll';
import IconLoaderClock from '../../../_Icons/IconLoaderClock';
import PollBar from '../PollBar';

import styles from './Poll.scss';

// const propTypes = {
//   params: React.PropTypes.shape({
//     schoolId: React.PropTypes.string,
//     pollId: React.PropTypes.string,
//     type: React.PropTypes.string,
//   }).isRequired,
//   location: React.PropTypes.shape({
//     pathname: React.PropTypes.string.isRequired,
//   }),
//   fastData: React.PropTypes.object,
//   poll: React.PropTypes.object,
//   actions: React.PropTypes.object.isRequired,
// };

const defaultProps = {
};

class Poll extends React.Component {
  state = {
    showReVote: false, // показать показать кнопки голосования, несмотря на то что уже проголосовал
  }

  componentDidMount() {
    const { actions, params: { pollId } } = this.props;
    actions.pollMakeInvalidate();
    actions.fetchPoll(pollId);
  }

  // $FlowFixMe
  UNSAFE_componentWillReceiveProps(nextProps) { // eslint-disable-line
    const { actions, params: { pollId } } = this.props;
    const newId = nextProps.params.pollId;
    if (pollId !== newId) {
      actions.fetchPoll(newId);
      this.setState({ showResults: false });
    }
  }

  handleVote = (e, choiceId) => {
    const { params: { pollId }, actions } = this.props;
    actions.vote(pollId, choiceId);
    this.setState({ showReVote: false });
  }

  handleEdit = (e) => {
    e.preventDefault();
    const { location: { pathname } } = this.props;
    let url = pathname.split('/').slice(0, 6);
    url = url.join('/');
    browserHistory.replace(`${url}/edit`);
  }

  handleShowResults = (e) => {
    e.preventDefault();
    this.setState({ showResults: true });
  }

  handleShowButtons = (e) => {
    e.preventDefault();
    this.setState({ showResults: false });
  }

  handleShowReVote = (e) => {
    e.preventDefault();
    this.setState({ showReVote: true });
  }

  handlePause = (e) => {
    e.preventDefault();
    const { params: { pollId }, actions } = this.props;
    actions.pausePoll(pollId);
  }

  handlePublish = (e) => {
    e.preventDefault();
    const { params: { pollId }, actions } = this.props;
    actions.publishPoll(pollId);
  }

  handleDelete = (e) => {
    e.preventDefault();
    const { params: { pollId }, actions, location: { pathname } } = this.props;
    let url = pathname.split('/').slice(0, 5);
    url = url.join('/');
    actions.deletePoll(pollId, () => {
      actions.popup('Опрос успешно удален');
      browserHistory.replace(url);
    });
  }

  renderTimeLeft = (status, endsAt) => {
    if (status !== 'ended') {
      const ms = moment(endsAt).diff(moment());
      const duration = moment.duration(ms);
      const days = Math.floor(duration.asDays());
      if (days < 1) {
        const hours = duration.hours();
        const minutes = duration.minutes();
        return <p>До окончания опроса {hours} {getNumEnding(hours, ['час', 'часа', 'часов'])} {minutes} {getNumEnding(minutes, ['минута', 'минуты', 'минут'])}</p>;
      }
      return <p>До окончания опроса {days} {getNumEnding(days, ['день', 'дня', 'дней'])}</p>;
    }
    return <p>Завершен</p>;
  }

  renderBars = (choices, perPercent) => choices.map((item, i) => {
    const percent = (item.votes_count && perPercent)
      ? Math.round(item.votes_count / perPercent)
      : 0;
    return (
      <PollBar
        key={i}
        percent={percent}
        title={`${item.title} (${percent}%)`}
        className={styles.barChoice}
        certColor={i + 1}
      />
    );
  })

  renderTimeComment = () => {
    const { poll: { endsAt, status } } = this.props;
    let text;
    switch (status) {
      case 'ended': {
        text = 'Голосование завершено';
        break;
      }
      case 'cancelled': {
        text = 'Голосование отменено';
        break;
      }
      default: {
        text = `Голосование завершится автоматически при достижении 100% количества голосовавших или ${moment(endsAt).format('DD.MM.YYYY')}`;
      }
    }

    return (
      <p className={styles.small}>
        {text}
      </p>
    );
  }

  renderButtons = () => {
    const { poll: { choices, status } } = this.props;
    if (status === 'active' || status === 'new') {
      return (
        <div className={styles.buttons}>
          <p>Ваш ответ:</p>
          {choices.map((item, i) =>
            <Button
              key={i}
              className={styles.btChoice}
              certColor={i + 1}
              data={item.id}
              onClick={this.handleVote}
            >
              {item.title}
            </Button>)}
        </div>
      );
    }
    return (
      <div className={styles.buttons}>
        <p>Вы не голосовали</p>
      </div>
    );
  }

  renderVotedButtons = (voted) => {
    const { poll: { votesLeft, status } } = this.props;
    const { showReVote } = this.state;
    const votesLeftText = (votesLeft === 1) ? 'один' : votesLeft;
    const text = votesLeft
      ? `Вы можете изменить решение только ${votesLeftText} ${getNumEnding(votesLeft, ['раз', 'раза', 'раз'])}!`
      : 'Вы уже меняли решение';
    const buttons = showReVote
      ? this.renderButtons()
      :
      (<div className={styles.buttons}>
        <Button onClick={this.handleShowReVote} disabled={!votesLeft}>Переголосовать</Button>
        <div className={styles.small} style={{ marginTop: 10 }}>{text}</div>
      </div>);
    return (
      <div className={styles.buttons}>
        <p>Вы проголосовали за вариант «{voted.title}»</p>
        {(status === 'active' || status === 'new') && buttons}
      </div>
    );
  }

  renderSettingsButtons = () => {
    const {
      location: { pathname },
      poll: { status, loading },
    } = this.props;
    // базовый путь
    let url = pathname.split('/').slice(0, 6);
    url = url.join('/');

    // Сообщение-черновик
    if (status === 'draft') {
      return (
        <div>
          <Button outline href={`${url}/edit`} className={styles.bt}>
            Редактировать
          </Button>
          <Button href="" outline className={styles.bt} onClick={this.handleDelete}>
            Удалить
          </Button>
          <Button href="" className={styles.bt} onClick={this.handlePublish}>
            Запустить
          </Button>
        </div>
      );
    }

    // Обычное сообщение, не оконченное
    if (status !== 'ended' && status !== 'cancelled') {
      return (
        <div className={styles.settings}>

          <Button
            outline
            className={styles.bt}
            onClick={this.handlePause}
            disabled={loading}
          >
            {(status === 'paused') ? 'Возобновить' : 'Приостановить'}
          </Button>

          {(status === 'new' || status === 'edited')
            &&
            <Button href={`${url}/edit`}>
              Редактировать
            </Button>}

        </div>
      );
    }

    return null;
  }

  render() {
    const {
      fastData,
      poll: {
        title,
        descr,
        choices,
        votes = 0,
        loading,
        votersAmount = 1,
        creator,
        createdAt,
        didInvalidate,
      },
    } = this.props;

    if (!this.props.poll || !fastData) return null;

    // голосование текущего пользователя
    const votedItem = choices && choices.find(item => item.voted); // может быть array при неудаче
    const isVoted = typeof votedItem === 'object';
    // проценты
    const votersPerPercent = votersAmount / 100.0;
    let votedPercent = Math.round(votes / votersPerPercent);
    votedPercent = ((votedPercent === 100) && (votes !== votersAmount)) ? 99 : votedPercent;
    const votedText = votes && (votedPercent || 'менее 1');

    if (didInvalidate) {
      return <IconLoaderClock className={styles.clock} style={{ margin: '0 auto' }} />;
    }

    // Результаты опроса
    return (
      <div className={styles.root}>
        {/* type === 'mypolls'
          && <a href="" className={styles.back} onClick={this.handleShowButtons}>←</a> */}
        <div className={styles.h2}>{title}</div>
        <div className={styles.descr}>{descr}</div>
        <PollBar percent={votes && (votedPercent || 1)} title={`Проголосовали (${votedText}%)`} />
        {this.renderTimeComment()}
        <div className={styles.bars}>
          {choices && this.renderBars(choices, votes / 100.0)}
        </div>

        {loading && <IconLoaderClock className={styles.clock} />}

        {!loading && (
          isVoted
            ? this.renderVotedButtons(votedItem)
            : (choices && this.renderButtons())
        )}

        <div className={styles.space} />
        <div className={styles.footer}>
          <div className={styles.settings}>
            {!loading && fastData.isOwner && this.renderSettingsButtons()}
          </div>
          <div className={styles.author}>
            Автор опроса: {creator}<br />
            Создан: {moment(createdAt).format('DD.MM.YYYY')}
          </div>
        </div>

      </div>
    );
  }
}

// Poll.propTypes = propTypes;
Poll.defaultProps = defaultProps;

const mapStateToProps = (store, ownProps) => {
  const { params: { pollId } } = ownProps;
  return ({
    fastData: store.fund.polls.data[pollId],
    poll: store.fund.poll,
  });
};


const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    ...pollActions,
    ...popupActions,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Poll);
